import { ProjectType } from "../../../common/constants"
import api from "../../api"

export type VisitNotesReportData = {
  jobId: number
  name: string
  sold: boolean
  jobType: ProjectType
  customerDisplayName: string
  clientNotes: string
  internalNotes: string
  dateUtc: Date
  userDisplayName: string
  timecardId: string
}

export const getVisitNotesReportData = async (startDate?: string, endDate?: string): Promise<VisitNotesReportData[]> => {
  return (await api.get(`/web/datacenter/visit-notes/${startDate}/${endDate}`)).data
}
